import makeStyles from '@mui/styles/makeStyles';
import React from "react";
import {useTranslation} from "react-i18next";
import {font, match, radius, type} from "common/tokens";

const useStyles = makeStyles({
  pill: {
    appearance: 'none',
    alignSelf: 'flex-start',
    flexShrink: 0,
    background: 'none',
    border: `1px solid ${match.CARD_SELECTED_BORDER}`,
    borderRadius: radius.CONTROL,
    padding: '3px 9px',
    cursor: 'pointer',
    color: match.ACCENT,
    ...type.label,
    fontWeight: font.BOLD,
  },
});

const InfoPill = ({onClick, label}) => {
  const classes = useStyles();
  const {t} = useTranslation();

  return (
    <button type={'button'} onClick={onClick} aria-label={label || t('moreInfo')} className={classes.pill}>
      {`${t('info')} ›`}
    </button>
  );
};

export default InfoPill;
